import { styled, type SxProps, type Theme } from '@mui/material'
import { forwardRef, type ComponentPropsWithoutRef } from 'react'

export type StatusDotColor = 'error' | 'warning' | 'info' | 'success' | 'brand' | 'neutral'

export type StatusDotProps = Omit<ComponentPropsWithoutRef<'span'>, 'color'> & {
  color?: StatusDotColor
  size?: 6 | 8
  sx?: SxProps<Theme>
}

const StatusDotRoot = styled('span', { name: 'OmuiStatusDot', slot: 'Root' })<{
  ownerState: { color: StatusDotColor; size: 6 | 8 }
}>(({ theme, ownerState }) => ({
  display: 'inline-block',
  verticalAlign: 'middle',
  width: ownerState.size,
  height: ownerState.size,
  borderRadius: theme.shape['radius-full'],
  backgroundColor: theme.palette.bg[ownerState.color === 'error' ? 'danger' : ownerState.color].default,
  flexShrink: 0,
}))

/** A status indicator. Give standalone dots an accessible label and role; hide decorative dots with aria-hidden. */
export const StatusDot = forwardRef<HTMLSpanElement, StatusDotProps>(function StatusDot(
  { color = 'neutral', size = 6, ...props },
  ref
) {
  return <StatusDotRoot ref={ref} ownerState={{ color, size }} {...props} />
})
